import moment from 'moment-timezone';

// only mess with this if game times are still messed up
// this is the ONLY place that manipulates game dates
// PARAMS:
// date: 'YYYY/MM/DD'
// time: 'HH:mm'
// timezone: 'America/New_York'

export const formatTimesUTC = (
  /** YYYY/MM/DD */
  date: string,
  /** HH:mm */
  time: string,
  /** America/New_York */
  timezone: string
) => {
  const format = 'YYYY/MM/DD HH:mm';

  const utcTime = moment.tz(`${date} ${time}`, format, timezone).utc().toISOString();

  return utcTime;
};

export default formatTimesUTC;
